import RgaSearchModel from '../state/rga-search-model';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateRgaSearchProperty = (state, action) => RgaSearchModel.update(state, {
    [action.property]: {
        $set: action.value
    }
});

const resetRgaSearchProperty = (state, action) => RgaSearchModel.update(state, {
    [action.property]: {
        $set: ''
    }
});

const updateRgaSearchListProperty = (state, action) => RgaSearchModel.update(state, {
    [action.property]: {
        $set: action.value
    }
});

const resetRgaSearchListProperty = (state, action) => RgaSearchModel.update(state, {
    [action.property]: {
        $set: []
    }
});

const resetRgaSearchDateValues = (state, action) => RgaSearchModel.update(state, {
    [action.property]: {
        $set: null
    }
});

const updateRgaSearchDropdownValues = (state, action) => RgaSearchModel.update(state, {
    [action.property]: {
        $set: action.value
    }
});

const resetRgaSearchForm = state => RgaSearchModel.update(state, {
    $set: {
        ...getDefaultState().rgaSearchModel,
        requestFromDate: 0,
        requestToDate: 0
    }
});

const setRequestDate = state => RgaSearchModel.update(state, {
    requestFromDate: {
        $set: new Date(Date.now() - 6 * 30 * 24 * 60 * 60 * 1000).getTime()
    },
    requestToDate: {
        $set: Date.now()
    }

});

export default (state = getDefaultState().rgaSearchModel, action) => {

    const actionTypes = {
        [actions.UPDATE_RGA_SEARCH_MODEL_OBJECT]: updateRgaSearchProperty,
        [actions.RESET_RGA_SEARCH_MODEL_OBJECT_VALUES]: resetRgaSearchProperty,
        [actions.UPDATE_RGA_SEARCH_MODEL_LIST_OBJECT]: updateRgaSearchListProperty,
        [actions.RESET_RGA_SEARCH_MODEL_LIST_OBJECT_VALUES]: resetRgaSearchListProperty,
        [actions.RESET_RGA_SEARCH_MODEL_OBJECT_DATE_VALUES]: resetRgaSearchDateValues,
        [actions.UPDATE_RGA_SEARCH_MODEL_OBJECT_DD_VALUES]: updateRgaSearchDropdownValues,
        [actions.RESET_RGA_SEARCH_MODEL_OBJECT]: resetRgaSearchForm,
        [actions.SET_REQUEST_DATE_SEARCH_MODEL]: setRequestDate
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/rga/search/reducers/rga-search.js